/* eslint-disable camelcase */
/* eslint-env browser */
/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import i18next from 'i18next';
import _ from 'lodash';
import { graphql } from 'react-relay';

import Separator from '~/modules/coreUI/components/layouts/helpers/Separator';
import { Label } from '~/modules/coreUI/components/basic/Labels';
import { Column, Row } from '~/modules/coreUI/components/layouts/helpers/LinearLayout';
import BrandsCards from '~/modules/ecommerceProducts/containers/productsTrack/BrandsCards';
import withRootQuery from '~/modules/core/utils/relayHelpers/withRootQuery';
import ItemsListSpinner from '~/modules/ecommerceCoreUI/components/listViewLayout/ItemsListSpinner';

import CategoryProductsList, { CARD_WIDTH } from './CategoryProductsList';

class SubDepartmentsInfo extends Component {
  state={
    maxNumberOfCards: 0,
  }

  componentDidMount = () => {
    this.setMaxNumberOfCard();
    window.addEventListener('resize', this.setMaxNumberOfCard);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.setMaxNumberOfCard);
  }

  setMaxNumberOfCard = _.debounce(() => {
    if ( document.getElementById('shopDetailsContainer').offsetWidth < 460 ){
      const numberOfCards = 2
      this.setState({ maxNumberOfCards: numberOfCards });
    }else {
      const numberOfCards = Math.floor(document.getElementById('shopDetailsContainer').offsetWidth / CARD_WIDTH);
      this.setState({ maxNumberOfCards: numberOfCards });
    }
  });

  render() {
    const {
      queryResult,
      vendorID,
      vendorName,
      isLoading,
    } = this.props;
    const { maxNumberOfCards } = this.state;
    return (
      isLoading ? (
        <ItemsListSpinner isVertical oneRow itemsCount={7} />
      ) : (
        queryResult && (
        <Column fullWidth leftAligned spaceBetween={1}>
          {queryResult && (
          <Label semiBold primary>{queryResult.taxons[0].name}</Label>
          )}
          {queryResult.taxons[0].children.map((subDepartment, index) => (
            <Column spaceBetween={1.5} key={subDepartment.id} fullWidth leftAligned>
              <Label md emphasized>{subDepartment.name}</Label>
              <CategoryProductsList
                category={subDepartment}
                maxNumberOfCards={maxNumberOfCards}
                departmentId={subDepartment.ref_id}
                departmentType={subDepartment.name}
              />
              { index !== queryResult.taxons[0].children.length - 1 && <Separator separatorLength="full" spacerSize={0.1} />}
            </Column>
          ))}
          {queryResult.taxons[0].top_brands.length > 0 && (
          <Column leftAligned fullWidth spaceBetween={1.5}>
            <Separator separatorLength="full" spacerSize={0.1} />
            <Label xxl semiBold primary>
              {i18next.t('eCommerceShops:ShopDetails.brands')}
            </Label>
            <Row fullWidth>
              <BrandsCards
                brandsInfo={queryResult.taxons[0].top_brands}
                departmentId={queryResult.taxons[0].ref_id}
                departmentName={queryResult.taxons[0].name}
                vendorID={vendorID}
                vendorName={vendorName}
              />
            </Row>
          </Column>
          )}
        </Column>
        )));
  }
}


SubDepartmentsInfo.defaultProps = {
  media: null,
  queryResult: null,
  taxonData: null,
};

SubDepartmentsInfo.propTypes = {
  queryResult: PropTypes.shape({}),
  media: PropTypes.shape({
    maxTablet: PropTypes.bool,
  }),
  taxonData: PropTypes.shape({}),
  vendorID: PropTypes.string.isRequired,
  vendorName: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

const SubDepartmentsInfoQuery = graphql`
query SubDepartmentsInfoQuery($type: TaxonKind, $vendor_id: ID, $id: ID) {
  taxons(type: $type, vendor_id: $vendor_id, id: $id) {
    id
    ref_id
    name
    logo
    caption
    type
    children(vendor_id: $vendor_id) {
      name
      id
      ref_id
      type
      caption
      products(vendor_id: $vendor_id , limit: 8){
        ...Product_productInfo @arguments(vendor_id: $vendor_id)
      }
      children(vendor_id: $vendor_id) {
        name
        id
        ref_id
        type
        caption
        products(vendor_id: $vendor_id , limit: 8){
          ...Product_productInfo @arguments(vendor_id: $vendor_id)
        }
      }
    }
    top_brands(vendor_id: $vendor_id) {
      ...BrandsCards_brandsInfo
    }
  }
}
`;

export default withRootQuery(
  SubDepartmentsInfo,
  SubDepartmentsInfoQuery,
  SubDepartmentsInfo,
  props => ({
    vendor_id: props.vendorID,
    id: props.currentDepartmentId,
    type: 'sub_department',
  }),
  { force: true },
);
